module.exports = __webpack_public_path__ + "static/media/slide2.40595120.jpg";